export function PageHeader({ title, subtitle, accent = "#0a6ed1", icon: Icon, children }) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4 rounded-lg border border-[#e5e9f0] bg-white px-5 py-4 shadow-sm">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="mt-0.5 flex h-10 w-10 items-center justify-center rounded-lg"
               style={{ background: `${accent}14`, color: accent }}>
            <Icon size={20} />
          </div>
        )}
        <div>
          <h1 className="text-xl sm:text-2xl font-semibold tracking-tight text-[#32363a] leading-tight">
            {title}
          </h1>
          {subtitle && <p className="mt-1 text-sm text-[#6a6d70] max-w-2xl">{subtitle}</p>}
        </div>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
